var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.handleClick}},[_vm._t("action-scroll",null,{"item":{ blank: _vm.isBlank, path: _vm.pathParsed }})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }